import { Immutable } from "immer";
import React from "react";
import { RetailStore } from "tsi-common-react/src/models/location";
import { SyncStoreID } from "tsi-common-react/src/models/nominals";
import {
    CSRF_HEADER,
    fetchJson,
    getCSRFToken,
} from "tsi-common-react/src/utils/ajax";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { jt, t } from "ttag";

import { LocatorSendResultsModal } from "../LocatorSendResults_Modal";
import { LocatorSurveyModal } from "../LocatorSurveyModal";
import { EmailLocatorResultsPostData } from "../models";
import { buildEmailStoreData } from "../utils";

const sendEmailWithStores = async (
    recipient: string,
    stores: Immutable<RetailStore[]>,
    selectedStores: Set<SyncStoreID>,
): Promise<void> => {
    const data: EmailLocatorResultsPostData = {
        email: recipient,
        stores: buildEmailStoreData(stores, selectedStores),
    };
    await fetchJson("/api/email-retail-locator-results", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            [CSRF_HEADER]: await getCSRFToken(),
        },
        body: JSON.stringify(data),
    });
};

export const LocatorSendResultsEmail = (props: {
    stores: Immutable<RetailStore[]>;
    getStoreNumber: (store: Immutable<RetailStore>) => number;
}): React.ReactNode => {
    const staticURL = useStaticURL();
    const [surveyOpen, setSurveyOpen] = React.useState(false);
    const [surveyEmail, setSurveyEmail] = React.useState("");

    const handleSubmit = async (
        recipient: string,
        selectedStores: Set<SyncStoreID>,
    ) => {
        await sendEmailWithStores(recipient, props.stores, selectedStores);
        setSurveyOpen(true);
        setSurveyEmail(recipient);
    };

    const handleSurveyClose = () => {
        setSurveyOpen(false);
    };

    return (
        <>
            <LocatorSendResultsModal
                modalClassName="modal-email"
                buttonLabel={t`Email Results`}
                buttonImgSrc={`${staticURL}img/retail-locator/icon-email.svg`}
                buttonImgAlt={t`Email Results`}
                modalTitle={t`Email Your Results`}
                modalDescription={(() => {
                    const maxNum = <strong key="max">10</strong>;
                    const results = <span key="results">{t`results`}</span>;
                    return jt`Check up to ${maxNum} ${results} you would like emailed.`;
                })()}
                inputType="email"
                inputPlaceholder={t`Enter an Email Address`}
                submitButtonLabel={t`Send`}
                maxSelected={10}
                stores={props.stores}
                getStoreNumber={props.getStoreNumber}
                onSubmit={handleSubmit}
            />
            <LocatorSurveyModal
                isOpen={surveyOpen}
                email={surveyEmail}
                onClose={handleSurveyClose}
            />
        </>
    );
};
